import React from 'react'
// components
import ApiClientsTab from './components/ApiClientsTab'
import ApiTokensTab from './components/ApiTokensTab'
// context
import ApiTokensPageAPI from 'containers/ApiTokens/layers/API'
import ApiClientsPageAPI from 'containers/ApiClients/layers/API'
// constants
import { REPORTING_TAB } from 'constants/apiSettings'

interface Props {
  tab: number
  setTab: (value: number) => void
}

const ApiSettings: React.FC<Props> = ({ tab, setTab }) => {
  if (tab === REPORTING_TAB) {
    return (
      <ApiTokensPageAPI>
        <ApiTokensTab tab={tab} setTab={setTab} />
      </ApiTokensPageAPI>
    )
  }

  return (
    <ApiClientsPageAPI>
      <ApiClientsTab tab={tab} setTab={setTab} />
    </ApiClientsPageAPI>
  )
}

export default ApiSettings
